module.exports = __webpack_public_path__ + "static/parade-2020-house37-71fa800e5b156563c1c0ad5ae1082fda.jpg";